import React from 'react';
import styled from 'styled-components';

/**
 *
 * @param {Object} props
 * @param {*} props.children
 * @param {*} props.tail
 * @param {Array<string>} props.tags
 * @returns
 */
export default function ModalHeader({ children, tags = [], tail }) {
  return (
    <Root>
      <Left>
        {children}
        {tags?.map((tag, index) => {
          if (typeof tag === 'string') {
            return <Tag key={index}>{tag}</Tag>;
          } else {
            return tag;
          }
        })}
      </Left>
      <Right>{tail}</Right>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  margin-right: 24px;
`;

const Tag = styled.div`
  background: rgba(102, 136, 255, 0.12);
  border-radius: 6px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  padding: 2px 10px;
  color: #6688ff;
  margin-left: 12px;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
`;
